export default "__VITE_ASSET__Bhos$CFO__"